module.exports = __webpack_public_path__ + "img/tree_3_4.4a3abf0b.png";